module.exports = __webpack_public_path__ + "static/media/car.cfe1fa81.svg";